/* @flow */
import ChatMessage from 'entities/ChatMessage';
import LayerTrigger from 'components/LayerTrigger.jsx';
import React from 'react';
import ReactionButton from 'chat/components/ReactionButton.jsx';
import Tooltip from 'components/Tooltip.jsx';

type Props = {
  message: ChatMessage,
  onShow: Function,
  onHide: Function,
  reactionPickerVisible?: boolean,
};

const TooltippedReactionButton = ({ message, onShow, onHide, reactionPickerVisible }: Props) => {
  const addReactionTooltip = (
    <Tooltip>
      <span>
        Add reaction
      </span>
    </Tooltip>
  );

  return (
    <LayerTrigger
      trigger={['hover', 'focus']}
      layer={reactionPickerVisible ? (<div />) : addReactionTooltip}
      placement="top">
      <div>
        <ReactionButton
          message={message}
          onShow={onShow}
          onHide={onHide}
        />
      </div>
    </LayerTrigger>
  );
};

export default TooltippedReactionButton;



// WEBPACK FOOTER //
// ./src/chat/components/TooltippedReactionButton.jsx